import React, { useState } from "react";
import { Shell } from "../components/Shell";
import { descargarArchivo, ApiError } from "../api";
import { useAuth } from "../auth/AuthContext";

export function Informes() {
  const { tienePermiso } = useAuth();
  const puedeGenerar = tienePermiso("informes:generar");
  const [generando, setGenerando] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [ultimaDescarga, setUltimaDescarga] = useState<string | null>(null);

  const generar = async () => {
    setGenerando(true);
    setError(null);
    try {
      const hoy = new Date().toISOString().slice(0, 10);
      await descargarArchivo(`/informes/ejecutivo?hasta=${hoy}`, `informe_ejecutivo_sigepro_${hoy}.pdf`);
      setUltimaDescarga(new Date().toLocaleString());
    } catch (e) {
      setError(e instanceof ApiError ? e.message : "No se pudo generar el informe ejecutivo.");
    } finally {
      setGenerando(false);
    }
  };

  return (
    <Shell titulo="Informes Ejecutivos" breadcrumb="Core / Informes Ejecutivos">
      <div className="flex items-center gap-2 mb-4">
        <p className="text-sm text-textmuted">
          Genera un informe ejecutivo en PDF con las cifras reales de la empresa: balance general, indicadores
          gerenciales, tesorería, activos fijos y nómina — cada uno con su gráfico — más un resumen ejecutivo
          redactado por IA a partir de esos mismos datos.
        </p>
        <span className="badge bg-amber-50 text-amber-700 border border-amber-200 text-[10px] shrink-0">Módulo premium</span>
      </div>

      <div className="card p-6 max-w-2xl">
        <h3 className="text-sm font-semibold text-slate-800 mb-1">Informe ejecutivo · núcleo privado</h3>
        <p className="text-sm text-textmuted mb-4">
          Incluye balance general, cartera pendiente y ventas facturadas, saldo por cuenta bancaria, valor en
          libros de activos fijos y total devengado de nómina, con la fecha de corte de hoy. La generación puede
          tardar unos segundos mientras se calculan las cifras, se dibujan los gráficos y se redacta el análisis.
        </p>

        {error && <div className="rounded-md bg-red-50 border border-red-200 px-3 py-2 text-sm text-red-700 mb-4">{error}</div>}
        {ultimaDescarga && !error && (
          <div className="rounded-md bg-accent-light border border-accent/20 px-3 py-2 text-sm text-accent-dark mb-4">
            Informe descargado ({ultimaDescarga}).
          </div>
        )}

        {puedeGenerar ? (
          <button className="btn-primary" onClick={generar} disabled={generando}>
            {generando ? "Generando informe..." : "Generar informe ejecutivo (PDF)"}
          </button>
        ) : (
          <p className="text-sm text-textmuted italic">Su rol no tiene permiso para generar informes ejecutivos ("informes:generar").</p>
        )}
      </div>
    </Shell>
  );
}
